import NProgress from 'nprogress/nprogress';
import 'nprogress/nprogress.css';

NProgress.configure({ showSpinner: false });

NProgress.fail = function fail() {
  if (document.querySelector('#nprogress .bar')) {
    document.querySelector('#nprogress .bar').style.background = '#f21b1b';
  }
  NProgress.done();
};

export default NProgress;
